export default {
    catclass(state) {
        return state.SF_CATCLASS;
    },

    setupCEUri: (state) => (uri) => {
        return uri + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
    },

    setupERPUri: (state) => (uri) => {
        return uri + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
    },

    // CE APIs
    init_uri(state, getters) { return getters.setupCEUri(state.INIT); },
    login_uri(state, getters) { return getters.setupCEUri(state.LOGIN); },
    change_password_uri(state, getters) { return getters.setupCEUri(state.CHANGE_PASSWORD); },
    forgot_password_uri(state, getters) { return getters.setupCEUri(state.FORGOT_PASSWORD); },
    menu_uri(state, getters) { return getters.setupCEUri(state.MENU); },
    get_ce_prod_attributes_uri(state, getters) { return getters.setupCEUri(state.GET_CE_PROD_ATTRIBUTES); },
    contact_us_uri(state, getters) { return getters.setupCEUri(state.CONTACT_US); },
    content_contact_us_uri(state, getters) { return getters.setupCEUri(state.CONTENT_CONTACT_US); },
    cat_prescript_uri(state, getters) { return getters.setupCEUri(state.CAT_PRESCRIP_SETT); },
    
    // ERP APIs
    // login_uri(state) {
    //     const URI = state.LOGIN + '&part=' + '' + state.erppartition + "&lang=" + state.language + "&_T=20210114";
    //     return URI;
    // },

    menu_categories_uri(state) {
        const URI = state.MENU_CATEGORIES + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    about_uri(state) {
        const URI = state.ABOUT + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    promo_uri(state) {
        const URI = state.PROMO_CONTENTS + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cat_prod_attr_uri(state) {
        const URI = state.CAT_PROD_ATTR + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    mail_subs_uri(state) {
        const URI = state.MAIL_SUBS + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    order_history_uri(state) {
        const URI = state.ORDER_HISTORY + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    openorders_uri(state) {
        const URI = state.OPEN_ORDERS + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    openinvoices_uri(state) {
        const URI = state.OPEN_INVOICES + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    invoice_details_uri(state) {
        const URI = state.INVOICE_DETAILS + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    paidinvoices_uri(state) {
        const URI = state.PAID_INVOICES + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    order_details_uri(state) {
        const URI = state.ORDER_DETAILS + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    partslist_uri(state) {
        const URI = state.PARTS_LIST + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    product_details_uri(state, getters) {
        return getters.setupERPUri(state.PRODUCT_DETAILS);
    },

    return_policy_uri(state) {
        const URI = state.RETURN_POLICY + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    expand_sel_uri(state) {
        const URI = state.EXPAND_SELECTION + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    shipped_uri(state) {
        const URI = state.SHIPPED_ORDERS + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    shipping_policy_uri(state) {
        const URI = state.SHIPPING_POLICY + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    search_parts_uri(state, getters) { return getters.setupERPUri(state.SEARCH_PARTS); },
    duplicate_items_uri(state, getters) { return getters.setupERPUri(state.DUPLICATE_ITEMS); },
    add_saved_order_uri(state, getters) { return getters.setupERPUri(state.ADD_SAVED_ORDER); },
    get_saved_order_uri(state, getters) { return getters.setupERPUri(state.GET_SAVED_ORDERS); },
    delete_saved_order_uri(state, getters) { return getters.setupERPUri(state.DELETE_SAVED_ORDER); },
    get_saved_order_parts_uri(state, getters) { return getters.setupERPUri(state.GET_SAVED_ORDER_PARTS); },
    get_saved_vehicle_uri(state, getters) { return getters.setupERPUri(state.GET_SAVED_VEHICLES); },
    add_saved_vehicle_uri(state, getters) { return getters.setupERPUri(state.ADD_SAVED_VEHICLE); },
    get_customer_info_uri(state, getters) { return getters.setupERPUri(state.GET_CUSTOMER_INFO); },
    get_customer_enrolled_uri(state, getters) { return getters.setupERPUri(state.GET_CUSTOMER_ENROLLED); },
    get_carriers(state, getters) { return getters.setupERPUri(state.GET_CARRIERS); },
    place_order_uri(state, getters) { return getters.setupERPUri(state.PLACE_ORDER); },
    get_saved_cc_uri(state, getters) { return getters.setupERPUri(state.GET_SAVED_CC); },
    removed_saved_cc_uri(state, getters) { return getters.setupERPUri(state.REMOVE_SAVED_CC); },
    substitute_parts_uri(state, getters) { return getters.setupERPUri(state.SUBSTITUTES_PARTS); },

    vehicle_years_uri(state) {
        const URI = state.VEHICLE_YEARS   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_makes_uri(state) {
        const URI = state.VEHICLE_MAKES   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_model_uri(state) {
        const URI = state.VEHICLE_MODEL   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_engine_uri(state) {
        const URI = state.VEHICLE_ENGINE   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_group_uri(state) {
        const URI = state.VEHICLE_GROUP   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    // year model endpoint is only available in  partslink
    vehicle_yrmodel_uri(state) {
        const URI = state.VEHICLE_YRMODEL   + '&w=Partslink&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_categories_uri(state) {
        const URI = state.VEHICLE_CATEGORIES   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_parts_uri(state) {
        const URI = state.VEHICLE_PARTS   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },
    
    counterman_uri(state) {
        const URI = state.VEHICLE_COUNTERMAN   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_type_uri(state) {
        const URI = state.VEHICLE_TYPE   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    interchange_manufacturers_uri(state, getters) { return getters.setupERPUri(state.INTERCHANGE_MANUFACTURERS); },
    interchange_substitutes_uri(state, getters) { return getters.setupERPUri(state.INTERCHANGE_SUBSTITUTES); },
    related_types_uri(state, getters) { return getters.setupERPUri(state.RELATED_TYPES); },
    related_items_uri(state, getters) { return getters.setupERPUri(state.RELATED_ITEMS); },

    vehicle_categoriesM_uri(state) {
        const URI = state.VEHICLE_CATEGORIESM   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_partsM_uri(state) {
        const URI = state.VEHICLE_PARTSM   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vehicle_typeM_uri(state) {
        const URI = state.VEHICLE_TYPEM   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    countermanM_uri(state) {
        const URI = state.VEHICLE_COUNTERMANM   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    buyers_guide(state) {
        const URI = state.BUYERS_GUIDE   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    vin_uri(state) {
        const URI = state.VIN   + '&w=' + state.STORE_FRONT + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cc_new_order(state){
        const URI = state.CC_NEW_ORDER  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cc_input_uri(state){
        const URI = state.CC_INPUT  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    // CE APIs

    ce_check_user(state){
        const URI = state.CHECK_CUST  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    ce_create_user(state){
        const URI = state.CREATE_CUST  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },
    
    stock_check(state){
        const URI = state.STOCK_CHECK  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    customer_locations_uri(state, getters) { return getters.setupERPUri(state.CUSTOMER_LOCATIONS); },
    wd_locations_uri(state, getters) { return getters.setupERPUri(state.WD_LOCATIONS); },
    wd_mfgs_uri(state, getters) { return getters.setupERPUri(state.WD_MFGS); },
    wd_credit_settings_uri(state, getters) { return getters.setupERPUri(state.WD_CREDIT_SETTINGS); },

    lost_log_sale(state){
        const URI = state.LOST_LOG_SALE  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    tax_rate_uri(state){
        const URI = state.TAX_RATE_URI  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    ship_rate_uri(state){
        const URI = state.SHIP_RATE_URI  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    promo_code_uri(state){
        const URI = state.PROMO_CODE_URI  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    email_ord_succ_uri(state){
        const URI = state.EMAIL_ORD_SUCC_URI  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    search_typeahead_uri(state){
        const URI = state.SEARCH_TYPEAHEAD  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    part_details_uri(state){
        const URI = state.PART_DETAILS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    related_parts_uri(state){
        const URI = state.RELATED_PARTS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    kit_master_uri(state){
        const URI = state.KIT_MASTER  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    last_category_uri(state){
        const URI = state.LAST_CATEGORIES  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    catlvl_names_uri(state){
        const URI = state.CATLVL_NAMES  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    popular_categs_uri(state){
        const URI = state.POPULAR_CATEGORIES  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cust_credit_status_uri(state){
        const URI = state.CUST_CREDIT_STATUS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cust_save_addr_uri(state){
        const URI = state.CUST_SAVE_ADDR  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cust_upd_shipto_uri(state){
        const URI = state.CUST_UPD_SHIPT  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    billing_status_uri(state){
        const URI = state.CUST_BILLING_STATUS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    validate_parts_uri(state){
        const URI = state.VALIDATE_PARTS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    cl_mware_uri(state){
        return state.CL_MWARE_URI  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
    },

    cl_mware_mfg_uri(state){
        return state.CL_MWARE_URI_MFG  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
    },

    cl_mware_swmetadata_uri(state){
        return state.CL_MWARE_SWMETADATA  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
    },

    catalog_list_uri(state){
        return state.CATALOG_LISTS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
    },
    
    // partslink only api
    pl_keysearch_uri(state) {
        const URI = state.PL_KEYSEARCH   + '&w=Partslink&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    pl_itemsearch_uri(state) {
        const URI = state.PL_ITEMSEARCH   + '&w=Partslink&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },
    
    pl_vh_keysearch_uri(state) {
        const URI = state.PL_VH_KEYSRC   + '&w=Partslink&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    pl_vh_grpsrc_uri(state) {
        const URI = state.PL_VH_GRPSRC   + '&w=Partslink&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },


    // return items web service
    return_reasons_uri(state){
        const URI = state.RETURN_REASONS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_validate_uri(state){
        const URI = state.RETURN_VALIDATE  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_submit_uri(state){
        const URI = state.RETURN_SUBMIT  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_savedlist_uri(state){
        const URI = state.RETURN_SAVEDLIST  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_load_uri(state){
        const URI = state.RETURN_LOAD  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_saved_uri(state){
        const URI = state.RETURN_SAVED  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_delete_uri(state){
        const URI = state.RETURN_DELETE  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_enable_uri(state){
        const URI = state.RETURN_ENABLED  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_nonrma_reasons_uri(state){
        const URI = state.RETURN_NONRMA_REASONS  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    return_nonrma_submit_uri(state){
        const URI = state.RETURN_NONRMA_SUBMIT  + '&part=' + state.erppartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    checkout_msgs_uri(state){
        const URI = state.CHECKOUT_MSGS  + '&part=' + state.cmlpartition + "&lang=" + state.language + "&_T=2020324";
        return URI;
    },

    // RESOURCE SPACE API
    // resource_api_user(state) {
    //     return state.RESOURCE_USER;
    // },
    // resource_api_key(state) {
    //     return state.RESOURCE_API_KEY;
    // },

    // base_resource_api(state) {
    //     return state.BASE_RESOURCE_API;
    // },

}